module.exports = __webpack_public_path__ + "static/img/SV.d4861b26.png";